module.exports = __webpack_public_path__ + "static/10-d7263d7a1378489f651908f2432ccf32.png";